import React, { useEffect, useState, useRef } from 'react';
import { SURAT_CENTER, MAP_RESTRICTION } from '../../../app/store/constant';

function JavascriptMap({ values, setMarkerDraggedLocation }) {
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    const [markerPosition, setMarkerPosition] = useState(SURAT_CENTER);

    // Update marker position when values change
    useEffect(() => {
        if (values && values.latitude && values.longitude) {
            const newPosition = { lat: values.latitude, lng: values.longitude };
            setMarkerPosition(newPosition);

            // Update marker position if marker already exists
            if (markerRef.current && mapRef.current) {
                markerRef.current.position = newPosition;
                mapRef.current.panTo(newPosition);
            }
        }
    }, [values]);

    useEffect(() => {
        async function loadMap() {
            if (!window.google || !window.google.maps) {
                throw new Error('Google Maps API not loaded');
            }

            try {
                const { Map } = await window.google.maps.importLibrary('maps');
                const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');

                // create map instance
                const map = new Map(document.getElementById('js-map'), {
                    zoom: 12,
                    center: markerPosition, // Use markerPosition here
                    mapId: 'DEMO_MAP_ID',
                    mapTypeControl: false,
                    streetViewControl: false,
                    restriction: {
                        latLngBounds: MAP_RESTRICTION.cityRestriction.surat,
                        strictBounds: true
                    }
                });
                mapRef.current = map;

                const marker = new AdvancedMarkerElement({
                    map: map,
                    position: markerPosition,
                    gmpDraggable: true
                });
                markerRef.current = marker;

                function getLocationWithGeoCode(position) {
                    const geocoder = new window.google.maps.Geocoder();
                    geocoder.geocode({ location: position }, (results, status) => {
                        if (status === 'OK') {
                            if (results[0]) {
                                const addressComponents = results[0].address_components;
                                const address = results[0].formatted_address;
                                const city = addressComponents.find((component) =>
                                    component.types.includes('locality')
                                )?.long_name;
                                const state = addressComponents.find((component) =>
                                    component.types.includes('administrative_area_level_1')
                                )?.long_name;
                                const postalCode = addressComponents.find((component) =>
                                    component.types.includes('postal_code')
                                )?.long_name;
                                const area = addressComponents.find((component) =>
                                    component.types.includes('sublocality')
                                )?.long_name;
                                const street = addressComponents.find((component) =>
                                    component.types.includes('route')
                                )?.long_name;
                                const venueName = addressComponents.find((component) =>
                                    component.types.includes('point_of_interest')
                                )?.long_name;
                                const country = addressComponents.find((component) =>
                                    component.types.includes('country')
                                )?.long_name;
                                const lat = position.lat;
                                const lng = position.lng;
                                const plusCode = results[0].plus_code;
                                const location = {
                                    address: address,
                                    city: city,
                                    state: state,
                                    postalCode: postalCode,
                                    area: area,
                                    street: street,
                                    venueName: venueName,
                                    country: country,
                                    lat: lat,
                                    lng: lng,
                                    plusCode: plusCode
                                };
                                setMarkerDraggedLocation(location); // Pass the location to the parent component
                            } else {
                                console.log('No results found');
                            }
                        } else {
                            throw new Error('Geocoder failed due to: ' + status);
                        }
                    });
                }

                // Add a drag event on marker
                marker.addListener('dragend', (e) => {
                    const position = marker.position;
                    getLocationWithGeoCode(position);
                });
            } catch (error) {
                throw new Error('Error loading map:', error);
            }
        }

        loadMap();
    }, [markerPosition]);

    return <div id="js-map" style={jsMapStyles}></div>;
}

export default JavascriptMap;

const jsMapStyles = {
    width: '515px',
    height: '316px'
};
